/**
 * 外部リンクURL定数
 */

// ヘルプサイト
export const HELP_BASE_URL = 'https://gendrive-help.hi-story.co.jp';
export const HELP_FAQ_ITEM_SETTING_TIPS = `${HELP_BASE_URL}/2e8588c9a0e480f39a30e4464e30c32d`;
export const HELP_FAQ_LAYOUT_NOTATION = `${HELP_BASE_URL}/2e8588c9a0e480bbb5f3ff97bae86b50`;
export const HELP_FAQ_OPERATION_STEPS = `${HELP_BASE_URL}/2f6588c9a0e4804592c5c6263faf0a71`;
export const HELP_FAQ_CONSUMPTION_COUNT = `${HELP_BASE_URL}/2f7588c9a0e480df956ce60cf405d7cf`;
export const HELP_FAQ_OCR_USAGE = `${HELP_BASE_URL}/313588c9a0e480649f4bcbe723a6370c`;
export const HELP_FAQ_AUTO_CLASSIFICATION = `${HELP_BASE_URL}/2f7588c9a0e480dbb5fcfe05c77febd6`;
// 「ファイルをアップロードする」ページ内「3. 対応ファイル形式と推奨環境」セクションへの直リンク（#2965 メール取り込みの添付制限案内）
export const HELP_FAQ_UPLOAD_FILE_SPEC = `${HELP_FAQ_OPERATION_STEPS}#314588c9a0e480f89474cb782199f850`;

// コーポレートサイト
export const CORPORATE_TERMS_URL = 'https://www.hi-story.co.jp/gen-drive/term/';
export const CORPORATE_PRIVACY_URL = 'https://www.hi-story.co.jp/gen-drive/privacy/';

// 動画
export const TUTORIAL_VIDEO_URL = 'https://youtu.be/W_HZr6NOyK0';
